import { Button } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import { useMutateProjectViewLink } from "../../hooks/useProjectViewLink";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import { Modal } from "../../lib/modal";
import type { LinkListTelemetryLocation } from "../LinkList/LinkList";

import style from "./UnpublishConfirmationModal.module.css";

export const UnpublishConfirmationModal = ({
  open,
  onClose,
  onUnpublishSuccess,
  viewLinkId,
  telemetryLocation,
}: {
  open: boolean;
  onClose: () => void;
  onUnpublishSuccess?: () => void;
  viewLinkId: string;
  telemetryLocation: LinkListTelemetryLocation;
}) => {
  const { teamID } = useParams();
  const tracker = useTracker();
  const { t, m } = useTranslation();
  const { mutate, error, isPending } = useMutateProjectViewLink({
    onSuccess: onClose,
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      title={t(m.ViewLink.UnpublishModalTitle)}
      telemetryName="unpublish_confirmation"
    >
      <div className={style.modalContainer}>
        <div>{t(m.ViewLink.UnpublishModalText)}</div>
        <Button
          disabled={isPending}
          variant="red"
          onClick={() => {
            tracker.trackUnpublishConfirmed({
              activeTeamId: String(teamID),
              viewLinkId: viewLinkId,
              type: "view_link",
              location: telemetryLocation,
            });
            mutate(
              { viewLinkId, body: { sharedState: "not_shared" } },
              { onSuccess: () => onUnpublishSuccess?.() }
            );
          }}
        >
          {t(m.ViewLink.UnpublishButton)}
        </Button>
        {error && (
          <div className={style.errorMessage}>
            <span>{t(m.ViewLink.UnpublishError)}</span>
          </div>
        )}
      </div>
    </Modal>
  );
};
